import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface ICRACreditInfoSetupFieldsPanel {
	dateDDL: any;
	payFrequencyDDLItems: any;
	onPeriodSelectionChangeHandler: (value: string) => void
}
export const CRACreditInfoSetupFieldsPanel: FC<
	ICRACreditInfoSetupFieldsPanel
> = ({ dateDDL, payFrequencyDDLItems, onPeriodSelectionChangeHandler }) => {
	return (
		<Box
		// sx={{
		// 	padding: "0",
		// 	"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
		// }}
		>
			<EnhancedDropDownRHFWithLabel
				label="Periods"
				selectName="period"
				testId={`period`}
				labelPosition={LabelPosition.Top}
				items={payFrequencyDDLItems ?? []}
				onSelectionChangeHandler={(e: any) => onPeriodSelectionChangeHandler(e.value)}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Date"
				selectName="date"
				testId={`date`}
				labelPosition={LabelPosition.Top}
				items={dateDDL}
			/>
			<RHookFormNumberFieldWithLabel
				label="Amount"
				id="amount"
				testId={`amount`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
